import { API } from "./constants"

class DataTransfer {
  
  constructor() {}

  async sendData(data: FormData) {
    console.log('Sending request, payload: ', data)

    const response = await fetch(API.basket.add, {
      method: 'POST',
      body: data,
    })
    
    if(response.ok) return response.text()
  }
}

export {
  DataTransfer,
}